import { CoreProductBrandsMultiselect } from './core-product-brands-multiselect';
import { CoreProductClassesMultiselect } from './core-product-classes-multiselect';
import { CoreProductCollectionTypesMultiselect } from './core-product-collection-types-multiselect';
import { CoreProductDepartmentsMultiselect } from './core-product-departments-multiselect';
import { CoreProductEventsMultiselect } from './core-product-events-multiselect';
import { CoreProductGroupsMultiselect } from './core-product-groups-multiselect';
import { CoreProductManufacturersMultiselect } from './core-product-manufacturers-multiselect';
import { CoreProductSeasonEventsMultiselect } from './core-product-season-events-multiselect';
import { CoreProductSeasonsMultiselect } from './core-product-seasons-multiselect';
import { CoreProductSubClassesMultiselect } from './core-product-sub-classes-multiselect';
import { CoreProductSubDepartmentsMultiselect } from './core-product-sub-departments-multiselect';
import { CoreProductsMultiselect } from './core-products-multiselect';

export const CoreProductMultiselect = {
  Brands: CoreProductBrandsMultiselect,
  CollectionTypes: CoreProductCollectionTypesMultiselect,
  Departments: CoreProductDepartmentsMultiselect,
  Events: CoreProductEventsMultiselect,
  Products: CoreProductsMultiselect,
  SeasonEvents: CoreProductSeasonEventsMultiselect,
  Seasons: CoreProductSeasonsMultiselect,
  SubDepartments: CoreProductSubDepartmentsMultiselect,
  ProductGroups: CoreProductGroupsMultiselect,
  Manufacturers: CoreProductManufacturersMultiselect,
  Classes: CoreProductClassesMultiselect,
  SubClasses: CoreProductSubClassesMultiselect,
};
